import { Component, Inject, OnInit } from '@angular/core';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MediaService } from '../../common/media.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-media-upload-dialog',
  templateUrl: './media-upload-dialog.component.html',
  styleUrls: ['./media-upload-dialog.component.css']
})
export class MediaUploadDialogComponent implements OnInit {

  rename: boolean = false;
  form ;
  constructor(
    public mediaManagerService: MediaService,
     private snotifyService: ToastrService,
    private dialogRef: MatDialogRef<MediaUploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
    this.form = data;
  }




  replaceMedia(){
    this.form.append('force','true');
    this.mediaManagerService.saveMedia(this.form).subscribe(()=>{
      this.openNotifyDone('replaced')
    },(error)=>{
      this.openNotifyError(error.message)
    })
      this.dialogRef.close('replace');
  }
  cancelMedia(){
    this.dialogRef.close('cancel');
  }

  ngOnInit() {
  }
  openNotifyError(message: string) {
    this.snotifyService.error(message, "Error!", {
     timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
  openNotifyDone(message: string) {
    this.snotifyService.success(message, "Done!", {
     timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

}
